import React from 'react';

function CallToActions() {
    function goToCalendly(e) {
        e.preventDefault();
        window.location.href = 'https://calendly.com/sethmichaelking';
    }

    return (
        <div className="px-5 animate-fade">
            <section className="">
                <div className="bg-gradient-to-r rounded from-indigo-500 from-10% via-sky-500 via-30% to-emerald-500 to-90% py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
                    <div className="w-full">
                        <div className="w-full flex flex-col items-center justify-between lg:flex-row">
                            <div className="mb-6 text-center lg:mb-0 lg:mr-16 lg:text-left">
                                <h2 className="h3 text-3xl font-orbiter mb-2 text-white">Ready to get organic results?</h2>
                                <p className="text-lg text-white opacity-75">Be seen as a thought leader and expert in your industry today.</p>
                            </div>
                            <div>
                                <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
                                    <button
                                        onClick={(e) => goToCalendly(e)}
                                        type="button"
                                        className="py-2.5 px-5 me-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                                    >
                                        Schedule Call
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default CallToActions; 